import { GzSearchablePolicyPanelBaseDataProvider } from './GzSearchablePolicyPanelBaseDataProvider';
import { Policy, PolicyCounters } from '@nirvana/shared/dtos/types/policies/common';

export class GzSearchablePolicyPanelGzDataProvider extends GzSearchablePolicyPanelBaseDataProvider {
  async getPolicyById(policyId: string): Promise<Policy> {
    const record = await this.dependencies.api.clients.Policies.ReadPolicy(policyId, 3).toPromise();

    if (!record || !record.data) {
      throw new Error('No policy data');
    }

    return record.data;
  }

  async getCounters(policyId: string): Promise<PolicyCounters> {
    const record = await this.dependencies.api.clients.Policies.getCounters(policyId, 3).toPromise();

    if (!record || !record[policyId]) {
      throw new Error('No policy data');
    }

    return record[policyId];
  }

  async getDefaultPolicy(): Promise<Policy> {
    const record = await this.dependencies.api.clients.Policies.getDefaultPolicy().toPromise();

    if (!record) {
      throw new Error('No policy data');
    }

    return record;
  }

  async getSuggestedNewPolicyName(): Promise<string> {
    const record = await this.dependencies.api.clients.Policies.getSuggestedNewPolicyName().toPromise();

    if (!record) {
      throw new Error('No policy data');
    }

    return record;
  }

  async generateSuggestedCloneName(clonedPolicyName: string): Promise<string> {
    const record = await this.dependencies.api.clients.Policies.generateSuggestedCloneName(
      clonedPolicyName
    ).toPromise();

    if (!record) {
      throw new Error('No policy data');
    }

    return record;
  }
}
